import React from 'react'
import cx from 'classnames'

import ServicesAreaItem from './ServicesAreaItem'
import Grid from '../../../../components/Grid'
import Icon, { EIconId } from '../../../../components/icons'
import { hasMinWidthOf, itemExistsInLocale } from '../../utils'
import { mainSections as _mainSections, metaSections as _metaSections, TSection } from './data'

import ELocale from '../../../../types/locales'

const ServiceArea: React.FC<{
  locale: ELocale
  mainSections?: TSection[]
  metaSections?: TSection[]
}> = (props) => {
  const { locale, mainSections = _mainSections, metaSections = _metaSections } = props

  const [currentIndex, setCurrentIndex] = React.useState<number>(-1)

  const handleClick = (index: number) => () => {
    // only handle clicks below tablet size
    if (!hasMinWidthOf('ms')) {
      setCurrentIndex(index === currentIndex ? -1 : index)
    }
  }

  return (
    <Grid.Container className="mt-32">
      <Grid.Row className="border-t-2 border-lightgrey-light sm:border-0">
        {mainSections.map((section, index) => {
          const isOpen = currentIndex === index
          return (
            <Grid.Col
              as="section"
              width={12}
              sm={4}
              md={3}
              className="border-b-2 border-lightgrey-light sm:border-0 pl-16 sm:pl-0"
              key={section.id}
            >
              <div
                className="flex justify-between items-center py-8 sm:mt-16 font-bold"
                data-id="section-header"
                onClick={handleClick(index)}
              >
                {section.title}
                <Icon
                  id={EIconId.ANGLE_DOWN}
                  className={cx('w-24 transition-transform duration-200 sm:hidden', {
                    'scale-100': !isOpen,
                    '-scale-100': isOpen,
                  })}
                />
              </div>
              <ul
                className={cx({
                  'sm:block hidden': !isOpen,
                  block: isOpen,
                })}
              >
                {section.items.map(
                  (item, index) =>
                    itemExistsInLocale(item, locale) && (
                      <ServicesAreaItem key={item.label} item={item} locale={locale} type="main" index={index} />
                    ),
                )}
              </ul>
            </Grid.Col>
          )
        })}
        <Grid.Col width={12} sm={8} md={3} className="mt-24 sm:mt-0">
          <Grid.Row>
            {metaSections.map((section) => (
              <Grid.Col
                as="section"
                width={6}
                sm={6}
                md={12}
                className={cx('text-center sm:text-left', section.className)}
                key={section.id}
              >
                <p className="flex justify-center sm:justify-start items-center py-8 mb-8 sm:mt-16 font-bold">
                  {section.title}
                </p>
                <ul>
                  {section.items
                    .filter((item) => itemExistsInLocale(item, locale))
                    .map((item, index) => (
                      <ServicesAreaItem key={item.label} item={item} locale={locale} type="meta" index={index} />
                    ))}
                </ul>
              </Grid.Col>
            ))}
          </Grid.Row>
        </Grid.Col>
      </Grid.Row>
    </Grid.Container>
  )
}

export { ServiceArea as default }
